<template>
   <div class="scalar-container">
    <div id="scalar-container" ref="scalarContainer"></div>
  </div>
</template>

<style>
  #scalar-container {
    height: 100vh;
  }
</style>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { createApiReference } from '@scalar/api-reference'
import '@scalar/api-reference/style.css' // обязательно подключи стили
import type { JsonDataResponse } from '~/types/types'
import { showErrorToast } from '~/types/helpers'

const {options} = useFetchHelper()
const scalarContainer = ref()

onMounted(async () => {
  const data = await $fetch<JsonDataResponse<any>>('/api/api-docs/marketing', options())

  if (!data.status) {
    showErrorToast(data.error)
    return
  }
  
  createApiReference(scalarContainer.value!, {
    content: data.data.doc,
    hiddenClients: true,
  })
});
</script>